import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import TodayIcon from "@mui/icons-material/Today";
import PeopleIcon from "@mui/icons-material/People";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { CW, currentUser } from "./cwUi";

/**
 * MOBILE-SHELL (3 Nov, design PDF page 3 "Coaching that works on a phone").
 * Phone / tablet only (below the "lg" width where the sidebar becomes a
 * drawer): bottom bar Today · Clients · Messages · More. "More" opens the
 * normal sidebar, so every old menu item is still one tap away.
 * Hidden on the review / feedback pages (they have their own bottom action
 * bar: "Write feedback"), in chat (its message box sits at the bottom)
 * and for team logins (no Today / Clients for them).
 */

const HIDE_ON = [/^\/coach\/review\//, /^\/chat/];

const ITEMS = [
  { value: "today", label: "Today", path: "/coach/today", icon: <TodayIcon />, match: /^\/coach\/today/ },
  { value: "clients", label: "Clients", path: "/coach/clients", icon: <PeopleIcon />, match: /^\/coach\/clients/ },
  { value: "messages", label: "Messages", path: "/chat", icon: <ChatBubbleOutlineIcon />, match: /^\/chat/ },
];

export default function CoachBottomNav({ onMore }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { userInfo } = useContentSetting() || {};
  const teamType = userInfo?.team_type ?? currentUser().team_type;
  if (teamType === "team") return null;
  if (HIDE_ON.some((re) => re.test(pathname))) return null;
  const active = ITEMS.find((it) => it.match.test(pathname))?.value || "";

  return (
    <Paper
      elevation={8}
      data-testid="coach-bottom-nav"
      sx={{
        display: { xs: "block", lg: "none" },
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1150,
        borderTop: `1px solid ${CW.line}`,
        pb: "env(safe-area-inset-bottom)",
      }}
    >
      <BottomNavigation
        showLabels
        value={active}
        onChange={(_e, value) => {
          if (value === "more") {
            if (onMore) onMore();
            return;
          }
          const item = ITEMS.find((it) => it.value === value);
          if (item) navigate(item.path);
        }}
        sx={{
          height: 60,
          "& .MuiBottomNavigationAction-root": { minWidth: 0, color: CW.muted },
          "& .Mui-selected": { color: `${CW.primary} !important` },
          "& .MuiBottomNavigationAction-label": { fontSize: "12px !important", fontWeight: 600 },
        }}
      >
        {ITEMS.map((it) => (
          <BottomNavigationAction key={it.value} value={it.value} label={it.label} icon={it.icon} />
        ))}
        <BottomNavigationAction value="more" label="More" icon={<MenuIcon />} />
      </BottomNavigation>
    </Paper>
  );
}
